/**
 * Determines if the app is currently rendering in an embedded context. This is
 * indicated by the path basename `/embed`. While this is active the app should
 * render a minimal UI for document shares and its subpaths.
 *
 * Although derived dynamically this value is treated as a constant
 * since it's value stays constant for the lifetime of the app.
 */
const IS_EMBEDDED = window.location.pathname.startsWith('/embed');
/**
 * Window name used for login via popup window.
 */
const EMBEDDED_SIGNIN_POPUP_WINDOW_NAME = 'sketch-signin-popup';

export { EMBEDDED_SIGNIN_POPUP_WINDOW_NAME, IS_EMBEDDED };
